/* eslint-disable */
import { useTranslation } from "react-i18next";
import { Button, Chip, Table, TableBody, TableCell, TableRow, TextField } from "@mui/material";
import { getEquipmentStatusesByQuery, patchEquipmentStatuses, postEquipmentStatuses } from "components/axios/equipmentAxios";
import { getEquipmentStatusBasicItemsByQuery, getEquipmentStatusItemsByQuery } from "components/axios/equipmentStatusItemsAxios";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import EquipmentListLayer from "components/layer/EquipmentListLayer";
import MainCard from "components/MainCard";

const EquipmentStatus = ({info}) => {
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };
    
    const [isWrite, setIsWrite] = useState(true);
    const [equipmentStatusBasicItems, setEquipmentStatusBasicItems] = useState(null);
    const [equipmentStatusItems, setEquipmentStatusItems] = useState(null);
    const [equipmentStatuses, setEquipmentStatuses] = useState(null);

    useEffect(()=>{
        if (info) {
            equipmentStatusesList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info, isWrite]);

    // 설비현황 목록
    const equipmentStatusesList = async () => {
        Promise.all([
            // 설비현황 기준관리에서 가져오기
            getEquipmentStatusBasicItemsByQuery({ "equipmentCtgr.id": info.equipmentCtgr.id, size:50, sort : "id,asc"}).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentStatusBasicItems;
                    if (list) {
                        setEquipmentStatusBasicItems(list);
                        return list;
                    } else {
                        setEquipmentStatusBasicItems(null);
                    }
                } else {
                    setEquipmentStatusBasicItems(null);
                }
                return null;
            })
            ,
            getEquipmentStatusItemsByQuery({ "equipmentCtgr.id": info.equipmentCtgr.id, size:50, sort : "id,asc"}).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentStatusItems;
                    if (list) {
                        setEquipmentStatusItems(list);
                        return list;
                    } else {
                    setEquipmentStatusItems(null);
                    }
                } else {
                    setEquipmentStatusItems(null);
                }
                return null;
            })
        ]).then((res)=>{
            if (res[0] && res[1]) {
                // 설비에 등록되어 있는 설비현황
                getEquipmentStatusesByQuery({ "equipment.id": info.id, size:50}).then((data) => {
                    if (data && data._embedded) {
                        const list = data._embedded.equipmentStatuses;
                        if (list) {
                            setEquipmentStatuses(list[0]);
                            setIsWrite(false);

                            let basicItems = list[0].basicItems && list[0].basicItems.filter(bItem => (bItem.itemId !== null && bItem.itemId !== undefined));
                            let statusItems = list[0].statusItems && list[0].statusItems.filter(sItem => (sItem.itemId !== null && sItem.itemId !== undefined));

                            let equipmentBasicItems = [];
                            res[0].map(function(bItem, i) {
                                let bVal = basicItems && basicItems.length > 0 ? basicItems.filter(item=>item.itemId == bItem.id)[0]?.value : '';
                                updateSetValue("basicValue"+i, bVal);
                                equipmentBasicItems.push({
                                    itemId : bItem.id,
                                    itemNm : bItem.itemNm,
                                    value : bVal
                                })
                            })
                            list[0].basicItems = equipmentBasicItems;

                            let equipmentItems = [];
                            res[1].map(function(sItem, i) {
                                let sVal = statusItems && statusItems.length > 0 ? statusItems.filter(item=>item.itemId == sItem.id)[0]?.value : '';
                                updateSetValue("value"+i, sVal);
                                equipmentItems.push({
                                    itemId : sItem.id,
                                    itemNm : sItem.itemNm,
                                    unit : sItem.unit,
                                    value : sVal
                                })
                            })
                            list[0].statusItems = equipmentItems;
                        } else {
                            setEquipmentStatuses(null);
                            setIsWrite(true);
                        }
                    } else {
                        setEquipmentStatuses(null);
                        setIsWrite(true);
                    }
                })
            }
        }).then((res2)=>{
            if (equipmentStatuses) {
                setIsWrite(false);
            } else {
                setIsWrite(true);
            }   
        })
    };

    let separate = "___";

    const {register, handleSubmit, formState : {isDirty, errors } } = useForm({});
    const onSubmit = (data, e) => {
        e.preventDefault();

        let body = {
            equipment : {
                id : info.id
            },
        };

        body.basicItems = [];
        for (var i=0 ; i < data.basicItemNmSize ; i++) {
            body.basicItems.push({
                itemId : eval('data.basicItemId'+i),
                itemNm : eval('data.basicItemNm'+i),
                value : eval('data.basicValue'+i)
            })
        }
        body.statusItems = [];
        for (var i=0 ; i < data.itemNmSize ; i++) {
            body.statusItems.push({
                itemId : eval('data.itemId'+i),
                itemNm : eval('data.itemNm'+i),
                unit : eval('data.unit'+i),
                value : eval('data.value'+i)
            })
        }
        
        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                postEquipmentStatuses(body).then((res)=>{
                    console.log(res);
                    equipmentStatusesList();
                }).catch((err)=>{
                    console.log(err);
                    if (!err.response?.data?.message) {
                        alertMessage = err.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    } else if (err.response.data.message) {
                        alertMessage = err.response.data.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    }
                });
                //reset();
            },
            onClose : () => {
                console.log('close');
            },
            message: t('message.common.alert.write.question'),
        });
    }

    const {register:updateRegister, handleSubmit:updateHandleSubmit, reset:updateReset, setValue:updateSetValue, formState : {isDirty:updateIsDirty, errors:updateErrors } } = useForm({});
    const onUpdateSubmit = (data, e) => {
        e.preventDefault();

        let body = {
            id : data.id,
            equipment : {
                id : info.id
            },
        };

        body.basicItems = [];
        for (var i=0 ; i < data.basicItemNmSize ; i++) {
            body.basicItems.push({
                itemId : eval('data.basicItemId'+i),
                itemNm : eval('data.basicItemNm'+i),
                value : eval('data.basicValue'+i)
            })
        }
        body.statusItems = [];
        for (var i=0 ; i < data.itemNmSize ; i++) {
            body.statusItems.push({
                itemId : eval('data.itemId'+i),
                itemNm : eval('data.itemNm'+i),
                unit : eval('data.unit'+i),
                value : eval('data.value'+i)
            })
        }

        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                patchEquipmentStatuses(body).then((res)=>{
                    console.log(res);
                    equipmentStatusesList();
                }).catch((err)=>{
                    console.log(err);
                    if (!err.response?.data?.message) {
                        alertMessage = err.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    } else if (err.response.data.message) {
                        alertMessage = err.response.data.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    }
                });
            },
            onClose : () => {
                console.log('close');
            },
            message: t('message.common.alert.modify.question'),
        });
    }

    // 가져오기
    const changeEquipment = (eId)=> {
        console.log(eId);
        if (eId !== info.id) {
            console.log('changeEquipmentStatuses start');
            Promise.all([
                // 현재 등록되어 있는 설비현황
                getEquipmentStatusesByQuery({"equipment.id": info.id, size:50}).then((data) => {
                    console.log(data);
                    if (data && data._embedded) {
                        const list = data._embedded.equipmentStatuses;
                        if (list) {
                            return list;
                        }
                    }
                    return null;
                })
                ,
                // 가져오기 하는 설비현황
                getEquipmentStatusesByQuery({"equipment.id": eId, size:50}).then((data) => {
                    console.log(data);
                    if (data && data._embedded) {
                        const list = data._embedded.equipmentStatuses;
                        if (list) {
                            return list;
                        }
                    }
                    return null;
                })
            ]).then((res)=>{
                if (res[1]) {   // 가져오기할 설비 현황 정리
                    let basicItems = res[1][0].basicItems.filter(bItem => (bItem.itemId !== null && bItem.itemId !== undefined));
                    let statusItems = res[1][0].statusItems.filter(sItem => (sItem.itemId !== null && sItem.itemId !== undefined));

                    let equipmentBasicItems = [];
                    equipmentStatusBasicItems.map(function(bItem, i) {
                        let bVal = basicItems && basicItems.length > 0 ? basicItems.filter(item=>item.itemId == bItem.id)[0]?.value : '';
                        equipmentBasicItems.push({
                            itemId : bItem.id,
                            itemNm : bItem.itemNm,
                            value : bVal
                        })
                    })
                    res[1][0].basicItems = equipmentBasicItems;

                    let equipmentItems = [];
                    equipmentStatusItems.map(function(sItem, i) {
                        let sVal = statusItems && statusItems.length > 0 ? statusItems.filter(item=>item.itemId == sItem.id)[0]?.value : '';
                        equipmentItems.push({
                            itemId : sItem.id,
                            itemNm : sItem.itemNm,
                            unit : sItem.unit,
                            value : sVal
                        })
                    })
                    res[1][0].statusItems = equipmentItems;
                }

                if (res[0]) { // 현재 등록되어 있는 설치현황 있다면 수정
                    let body = {
                        id : res[0][0].id,
                        equipment : {
                            id : info.id
                        },
                    };
            
                    if (res[1]) {
                        body.basicItems = [];
                        res[1][0].basicItems.map(function(bItem, i) {
                            body.basicItems.push({
                                itemId : bItem.itemId,
                                itemNm : bItem.itemNm,
                                value : bItem.value
                            })
                        })
                        body.statusItems = [];
                        res[1][0].statusItems.map(function(sItem, i) {
                            body.statusItems.push({
                                itemId : sItem.itemId,
                                itemNm : sItem.itemNm,
                                unit : sItem.unit,
                                value : sItem.value
                            })
                        })
                    } else {
                        body.basicItems = [];
                        res[0][0].basicItems.map(function(bItem, i) {
                            body.basicItems.push({
                                itemId : bItem.itemId,
                                itemNm : bItem.itemNm,
                                value : ''
                            })
                        })
                        body.statusItems = [];
                        res[0][0].statusItems.map(function(sItem, i) {
                            body.statusItems.push({
                                itemId : sItem.itemId,
                                itemNm : sItem.itemNm,
                                unit : sItem.unit,
                                value : ''
                            })
                        })
                    }
                    console.log(body);
                    patchEquipmentStatuses(body);
                } else { // 현재 등록되어 있는 설치현황 없다면 등록
                    if (res[1]) {
                        console.log(res[1][0]);
                        let body = {
                            equipment : {
                                id : info.id
                            },
                        };
                
                        body.basicItems = [];
                        res[1][0].basicItems.map(function(bItem, i) {
                            body.basicItems.push({
                                itemId : bItem.itemId,
                                itemNm : bItem.itemNm,
                                value : bItem.value
                            })
                        })
                        body.statusItems = [];
                        res[1][0].statusItems.map(function(sItem, i) {
                            body.statusItems.push({
                                itemId : sItem.itemId,
                                itemNm : sItem.itemNm,
                                unit : sItem.unit,
                                value : sItem.value
                            })
                        })
                        console.log(body);
                        postEquipmentStatuses(body);
                    }
                }
                
                setTimeout(() => equipmentStatusesList(), 1000);
            })
        }
    }

    if (info) {
        if (!isWrite) {    // 수정
            return (
            <div>
                <MainCard style={{marginTop:"10px"}}>
                <Chip label={t('message.common.chip.equipment.status')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
                    <EquipmentListLayer excludeId={info.id} equipmentCtgrId={info.equipmentCtgr.id} changeEquipment={changeEquipment} />
                    <form onSubmit={updateHandleSubmit(onUpdateSubmit)}>
                    <input type="hidden" {...updateRegister('id')} value={equipmentStatuses.id} />
                    <Table style={{borderTop:"2px solid #a2a2a2"}} sx={{ minWidth: 400 }} aria-label="simple table" className="same_width">
                        <TableBody style={{height:"auto"}}>
                            {equipmentStatuses && equipmentStatuses.basicItems && equipmentStatuses.basicItems.map(function(item, i) {
                            return (
                            <TableRow key={i}>
                                <TableCell className="th" align="center" colSpan="2">{item.itemNm}</TableCell>
                                <TableCell colSpan="2" align="center">
                                    <input type="hidden" {...updateRegister(`basicItemId${i}`)} value={item.itemId} />
                                    <input type="hidden" {...updateRegister(`basicItemNm${i}`)} value={item.itemNm} />
                                    <TextField id="outlined-basic" 
                                    key={item.itemNm}
                                    aria-invalid={!updateIsDirty ? undefined : eval(`updateErrors.basicValue${i}`) ? "true" : "false"}
                                    defaultValue={item.value || ''} 
                                    {...updateRegister(`basicValue${i}`, {
                                      required : (item.itemNm.replaceAll(separate,''))+" "+t('message.common.error.text.value.input')
                                    })} 
                                    sx={{ minWidth: '90%' }} />
                                    {eval(`updateErrors.basicValue${i}`) && <small role="alert"><br></br>{eval(`updateErrors.basicValue${i}.message`)}</small>}
                                </TableCell>
                            </TableRow>
                                )
                            }) }
                            <TableRow>
                                <TableCell className="th" align="center" colSpan="2">{t('message.common.subtitle.item')}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.unit')}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.design.value')}</TableCell>
                            </TableRow>
                            { equipmentStatuses && equipmentStatuses.statusItems && equipmentStatuses.statusItems.map(function(item2, i) {
                                    let itemName = item2.itemNm ? item2.itemNm.split(separate) : "_________".split(separate);
                                    return (
                            <TableRow key={i}>
                                {(itemName[0] || itemName[1]) && 
                                <>
                                <TableCell align="center">{itemName[0]}{itemName[1] && (' | '+itemName[1])}</TableCell>
                                <TableCell align="center">{itemName[2]}</TableCell>
                                </>
                                }
                                {!(itemName[0] || itemName[1]) && 
                                <>
                                <TableCell colSpan="2" align="center">{itemName[2]}</TableCell>
                                </>
                                }
                                <TableCell align="center">{item2.unit}</TableCell>
                                <TableCell align="center">
                                    <input type="hidden" {...updateRegister(`itemId${i}`)} value={item2.itemId} />
                                    <input type="hidden" {...updateRegister(`itemNm${i}`)} value={item2.itemNm || "_________"} />
                                    <input type="hidden" {...updateRegister(`unit${i}`)} value={item2.unit} />
                                    <TextField id="outlined-basic" 
                                    aria-invalid={!updateIsDirty ? undefined : eval(`updateErrors.value${i}`) ? "true" : "false"}
                                    defaultValue={item2.value || ''} 
                                    {...updateRegister(`value${i}`, {
                                      required : ((item2.itemNm || "_________").replaceAll(separate,''))+" "+t('message.common.error.text.value.input')
                                    })} 
                                    sx={{ minWidth: '90%' }} />
                                    {eval(`updateErrors.value${i}`) && <small role="alert"><br></br>{eval(`updateErrors.value${i}.message`)}</small>}
                                </TableCell>
                            </TableRow>
                                    )
                                //}
                            }) }
                        </TableBody>
                    </Table>
                    {equipmentStatusBasicItems && <input type="hidden" {...updateRegister('basicItemNmSize')} value={equipmentStatusBasicItems.length} />}
                    {equipmentStatusItems && <input type="hidden" {...updateRegister('itemNmSize')} value={equipmentStatusItems.length} />}
                    </form>
                </MainCard>

                <div className="btn_right" style={{margin:"8px"}}>
                    <Button variant="contained" color="success" onClick={updateHandleSubmit(onUpdateSubmit)}>{t('message.common.btn.modify')}</Button>
                </div>
            </div>
                )
        } else {    // 등록
            return (
            <div>
                <MainCard style={{marginTop:"10px"}}>
                    <div style={{marginBottom:"10px"}}>
                        <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                        <Chip label={t('message.common.chip.equipment.status')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />&nbsp;&nbsp;
                        <EquipmentListLayer excludeId={info.id} equipmentCtgrId={info.equipmentCtgr.id} changeEquipment={changeEquipment} />
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)}>
                    <Table style={{borderTop:"2px solid #a2a2a2"}} sx={{ minWidth: 400 }} aria-label="simple table" className="same_width">
                        <TableBody style={{height:"auto"}}>
                            { equipmentStatusBasicItems && equipmentStatusBasicItems.map(function(item, i) {
                            return (
                            <TableRow key={i}>
                                <TableCell className="th" align="center" colSpan="2">{item.itemNm}</TableCell>
                                <TableCell colSpan="2" align="center">
                                    <input type="hidden" {...register(`basicItemId${i}`)} value={item.id} />
                                    <input type="hidden" {...register(`basicItemNm${i}`)} value={item.itemNm} />
                                    <TextField id="outlined-basic" 
                                    aria-invalid={!isDirty ? undefined : eval(`errors.basicValue${i}`) ? "true" : "false"}
                                    defaultValue={item.value || ''} 
                                    {...register(`basicValue${i}`, {
                                      required : (item.itemNm.replaceAll(separate,''))+" "+t('message.common.error.text.value.input')
                                    })} 
                                    sx={{ minWidth: '90%' }} />
                                    {eval(`errors.basicValue${i}`) && <small role="alert"><br></br>{eval(`errors.basicValue${i}.message`)}</small>}
                                </TableCell>
                            </TableRow>
                                )
                            }) }
                            <TableRow>
                                <TableCell className="th" align="center" colSpan="2">{t('message.common.subtitle.item')}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.unit')}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.design.value')}</TableCell>
                            </TableRow>
                            { equipmentStatusItems && equipmentStatusItems.map(function(item2, i) {
                                let itemName = item2.itemNm ? item2.itemNm.split(separate) : "_________".split(separate);
                            return (
                            <TableRow key={i}>
                                {(itemName[0] || itemName[1]) && 
                                <>
                                <TableCell align="center">{itemName[0]}{itemName[1] && (' | '+itemName[1])}</TableCell>
                                <TableCell align="center">{itemName[2]}</TableCell>
                                </>
                                }
                                {!(itemName[0] || itemName[1]) && 
                                <>
                                <TableCell colSpan="2" align="center">{itemName[2]}</TableCell>
                                </>
                                }
                                <TableCell align="center">{item2.unit}</TableCell>
                                <TableCell align="center">
                                    <input type="hidden" {...register(`itemId${i}`)} value={item2.id} />
                                    <input type="hidden" {...register(`itemNm${i}`)} value={item2.itemNm} />
                                    <input type="hidden" {...register(`unit${i}`)} value={item2.unit} />
                                    <TextField id="outlined-basic" 
                                    aria-invalid={!isDirty ? undefined : eval(`errors.value${i}`) ? "true" : "false"}
                                    defaultValue={item2.value || ''} 
                                    {...register(`value${i}`, {
                                      required : (item2.itemNm.replaceAll(separate,''))+" "+t('message.common.error.text.value.input')
                                    })} 
                                    sx={{ minWidth: '90%' }} />
                                    {eval(`errors.value${i}`) && <small role="alert"><br></br>{eval(`errors.value${i}.message`)}</small>}
                                </TableCell>
                            </TableRow>
                                )
                            }) }
                        </TableBody>
                    </Table>
                    {equipmentStatusBasicItems && <input type="hidden" {...register('basicItemNmSize')} value={equipmentStatusBasicItems.length} />}
                    {equipmentStatusItems && <input type="hidden" {...register('itemNmSize')} value={equipmentStatusItems.length} />}
                    </form>
                </MainCard>
                {(equipmentStatusBasicItems || equipmentStatusItems) &&
                <div className="btn_right" style={{margin:"8px"}}>
                    <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</Button>
                </div>
                }
            </div>
            )
        }
    }
}
export default EquipmentStatus;